import { taggedTemplateLiteral as _taggedTemplateLiteral, asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { gql } from '@apollo/client';

var _templateObject;
var doorWindowQuery = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query DoorWindow($giid: String!, $deviceLabel: String!) {\n    installation(giid: $giid) {\n      doorWindows(filter: { deviceLabels: [$deviceLabel] }) {\n        device {\n          deviceLabel\n          area\n          gui {\n            support\n            label\n          }\n        }\n        type\n        state\n        wired\n        reportTime\n      }\n    }\n  }\n"])));
var refreshDoorWindowAsync = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(client, giid, deviceLabel) {
    var result, doorWindows;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return client.query({
              query: doorWindowQuery,
              variables: {
                giid: giid,
                deviceLabel: deviceLabel
              }
            });
          case 3:
            result = _context.sent;
            doorWindows = result.data.installation.doorWindows;
            return _context.abrupt("return", doorWindows[0]);
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            if (_context.t0.networkError) {
              _context.next = 12;
              break;
            }
            throw _context.t0;
          case 12:
            return _context.abrupt("return", null);
          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 8]]);
  }));
  return function refreshDoorWindowAsync(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

export { doorWindowQuery, refreshDoorWindowAsync };
